
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationSourceDataAllocations, QueryConfigurationSourceDataAllocationsResponse, ConfigurationSourceDataAllocation } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationSourceDataAllocationsResponse, QueryConfigurationSourceDataAllocationsResponse>) => {
    if (!response ||
        !response.data ||
        !response.data.data ||
        response.data.data.length === 0
    ) {
        return undefined;
    }

    return [...response.data.data].sort((a, b) => a.order! > b.order! ? 1 : -1)
};
const getError = (response?: SWRResponse<QueryConfigurationSourceDataAllocationsResponse, QueryConfigurationSourceDataAllocationsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationSourceDataAllocationsResponse, QueryConfigurationSourceDataAllocationsResponse>) => ({});

export const useConfigurationSourceDataAllocations = (query?: Partial<ConfigurationSourceDataAllocation>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationSourceDataAllocations(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationSourceDataAllocations;